import type { AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

const env = import.meta.env;

export function apiBaseUrl(): string {
  return (env.VITE_API_BASE_URL as string) ?? "https://api-dev.humancreator.com";
}

// Cognito hosted-UI's /logout endpoint is not OIDC-compliant — it expects
// `client_id` + `logout_uri` (not `post_logout_redirect_uri`). Build the
// URL ourselves and navigate to it. Borrowed from support-app-v2.
export function cognitoLogoutUrl(): string {
  const domain = env.VITE_COGNITO_DOMAIN as string;
  const clientId = env.VITE_COGNITO_CLIENT_ID as string;
  const logoutUri = `${window.location.origin}/dawsonscreek/`;
  const params = new URLSearchParams({
    client_id: clientId,
    logout_uri: logoutUri,
  });
  return `https://${domain}/logout?${params.toString()}`;
}

export function oidcConfig(): AuthProviderProps {
  return {
    authority: env.VITE_COGNITO_AUTHORITY as string,
    client_id: env.VITE_COGNITO_CLIENT_ID as string,
    redirect_uri: `${window.location.origin}/dawsonscreek/auth/callback`,
    post_logout_redirect_uri: `${window.location.origin}/dawsonscreek/`,
    response_type: "code",
    scope: "openid email profile",
    automaticSilentRenew: true,
    loadUserInfo: false,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    onSigninCallback: () => {
      // Strip OIDC params from the URL once the callback completes.
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };
}
